module.exports = __webpack_public_path__ + "img/img_2.3d4f9f47.png";